import { DetalleGrupoDiscapacidadComponent } from './detalle-grupo-discapacidad.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ConfiguracionDiscapacidadComponent } from './configuracion-discapacidad.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfiguracionDiscapacidadRoutingModule } from './configuracion-discapacidad-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/formulario/', '.json');
}


@NgModule({
  declarations: [ConfiguracionDiscapacidadComponent, DetalleGrupoDiscapacidadComponent],
  imports: [
    ConfiguracionDiscapacidadRoutingModule,
    SharedModule,
    CommonModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
      isolate: true
    })
  ],
  entryComponents: []
})
export class ConfiguracionDiscapacidadModule { }
